import React from "react";
import { features } from "../data/mock";
import * as Icons from "lucide-react";

const Features = () => {
  return (
    <section id="features" className="py-24 section-gradient">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="mono-pixel text-[#ffcb05] tracking-[0.3em] text-sm mb-3">// FEATURES</p>
          <h2 className="pixel-font text-2xl sm:text-3xl text-white title-deco">A FULL ADVENTURE</h2>
          <p className="text-white/60 mt-6 max-w-2xl mx-auto">
            Built entirely on the client side with no backend — yet packed with everything you’d expect from a serious monster-catching RPG.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <div
                key={i}
                className="feature-card relative p-7 rounded-xl border border-white/10 bg-white/[0.03] backdrop-blur-sm"
              >
                <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-[#ffcb05]/15 border border-[#ffcb05]/30 mb-5">
                  <Icon size={22} className="text-[#ffcb05]" />
                </div>
                <h3 className="pixel-font text-[#ffcb05] text-xs mb-3 leading-relaxed">{f.title.toUpperCase()}</h3>
                <p className="text-white/65 text-sm leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
